export default __webpack_public_path__ + "static/media/save.9d915a71.svg";